import {
  selectActiveRoomsFilter,
  selectActiveStatusFilter,
  selectActiveTypeFilter,
} from '../../../../selectors/offersHistory';
import { ETypeFilterValues } from '../../../../types/offerHistory';
import { TThunkAction } from '../../../../types/redux';
import { trackOffersHistoryFiltersChange } from './tracking';

const mapLocationVal: Record<ETypeFilterValues, string> = {
  [ETypeFilterValues.NearbyHouses]: 'similar',
  [ETypeFilterValues.SameHouse]: 'this',
};

export const trackFiltersChange = (): TThunkAction => (_, getState) => {
  const state = getState();
  const roomsFilterValue = selectActiveRoomsFilter(state) || 'all';
  const statusFilterValue = selectActiveStatusFilter(state) || 'all';
  const typeFilterValue = selectActiveTypeFilter(state) as ETypeFilterValues;

  trackOffersHistoryFiltersChange(`${mapLocationVal[typeFilterValue]}/${statusFilterValue}/${roomsFilterValue}`);
};
